import { ScrollablePane, DetailsList, DetailsListLayoutMode, ConstrainMode, SelectionMode, Sticky, StickyPositionType, Spinner,CommandBar, initializeIcons, Icon, Dropdown, IDropdownOption,  DetailsRow, IColumn, SearchBox, getTheme } from "@fluentui/react";
import React from "react";
import { Subtests } from "./subtests";
export interface WebsitesProps {

}

export interface WebsitesState {
	sites:any[],
	allsites:any[],
	tests:any[],
	subtests:any[],
	testOutput:any[],
	index:number,
	testIndex:number,
	lastStart:number,
	lastPeriod:number,
	testCount:number,
	lastTestCount:number,
	pause:boolean,
	server:string,
	search:string,
	testTimeout:number,
	subtestIndex:number,
	limitSites:number

}

export class Websites extends React.Component<WebsitesProps,WebsitesState> {
	state: Readonly<WebsitesState> = {
		sites:[],
		allsites:[],
		tests:[],
		subtests:[],
		index:0,
		testIndex:0,
		testOutput:[],
		pause:false,
		lastStart:(new Date()).getTime(),
		lastPeriod:0,
		server:"alle",
		search:"",
		testTimeout:100,
		testCount:0,
		lastTestCount:0,
		subtestIndex:0,
		limitSites:3
	};
	getData(){
		fetch('https://tools.vsrv1.webkommunikation24.de/website-monitor/api/tests').then(res=>res.json()).then((res:any)=>{
			this.setState({tests:res},()=>{
						
				fetch('https://tools.vsrv1.webkommunikation24.de/website-monitor/api/domain-list').then(res=>res.json()).then((res:any)=>{
 
					this.setState({
						sites:res
							.filter((site:any)=>site.cms?.version !== 'im Archiv')
							//.filter((site:any, index:number)=>site.projekt_id?.indexOf(999)>=0 )
							,
						allsites:res},()=>

							fetch('https://tools.vsrv1.webkommunikation24.de/website-monitor/api/results')
							.then(res=>res.json())
							.then((res:any)=>{
								let testOutput =JSON.parse(JSON.stringify(this.state.testOutput));
								let subtests =  [...this.state.subtests];
								let LoadSubtets:any[] = [];
								res.forEach((element:any) => {
									let index=(this.state.sites.map((site:any)=>parseInt(site.id,10)).indexOf(element.instanz))
									let testIndex = Object.keys(this.state.tests).indexOf(element.test);
									//console.debug(element)
									//console.debug(this.state.sites[index])
									if (index >=0 && testIndex >=0 ) {
										delete element.instanz; delete element.test;
										
										if (typeof(testOutput[index])==='undefined') {
											testOutput[index] = {};
										}
										
										testOutput[index][testIndex] = JSON.parse(JSON.stringify(element)).result;
										testOutput[index][testIndex].lastRun=element.lastRun; 
										if (typeof(element.result.subtests)!=='undefined'){
											subtests = subtests.filter((subtest:any) => !(subtest.index === index && subtest.testIndex===testIndex  )) 
											element.result.subtests?.forEach((test:any, subtestIndex:number)=>{
												test.index = index;
												test.testIndex = testIndex;
												test.subtestIndex = subtestIndex;
												test.domain = this.state.sites[this.state.index];
												subtests.push(JSON.parse(JSON.stringify(test)))
											})
										}
									} else {
										if (testIndex === -1 ) {
											LoadSubtets.push(element);
											
										}
									}
								});
								LoadSubtets.forEach((LST:any)=>{
									subtests.forEach((ST:any, index:number)=>{
										if (ST?.title == LST?.result?.title ) {
											for(let attr in LST)
												subtests[index][attr] = JSON.parse(JSON.stringify(LST[attr]));
											
											subtests[index].run = 1;
										}
									})
								})
								this.setState({testOutput:testOutput, subtests:subtests}, ()=>this.test())

								
							})
					)
				})
			})
		})
	}
	componentDidMount(): void {
		this.getData();
		initializeIcons();
	}
	componentDidUpdate(prevProps: Readonly<WebsitesProps>, prevState: Readonly<WebsitesState>, snapshot?: any): void {
		if (prevState.index !== this.state.index || prevState.testIndex !== this.state.testIndex ) {
			window.setTimeout(
				()=>this.test(),
				this.state.testTimeout 
			)
		}
	}
	getTest(testIndex:number, index:number):any{
		const domain = this.state.sites[index] ;
		let test=Object.keys(this.state.tests)[testIndex]
		let Test:any;
		for (let i in this.state.tests) {
			if (i===test){
				Test = this.state.tests[i]
			}
		}
		
		const body = {
			domain: domain,
			test: test,
			index:this.state.index,
			testIndex:this.state.testIndex
		};
		let lastRun = (this.state.testOutput[body.index||0]?.[body.testIndex||0]?.lastRun || (new Date).getTime()/1000  - Test.minIntervall );
		
		let haveToRun:boolean = (new Date).getTime()/1000  - lastRun > Test.minIntervall;
		haveToRun = haveToRun || (typeof(this.state.testOutput[body.index||0]?.[body.testIndex||0])==='undefined');
		return {body:body, lastRun:lastRun, Test:Test, haveToRun:haveToRun}
	}
	test(){
		//console.debug('test()');
		if ((!this.state.pause) && (this.state.sites.length > 0) && (Object.keys(this.state.tests).length > 0)){
			const domain = this.state.sites[this.state.index] ;
			let {body,lastRun,haveToRun,Test} = this.getTest(this.state.testIndex, this.state.index);

			if(haveToRun){
				   fetch('https://tools.vsrv1.webkommunikation24.de/website-monitor/api/test?'+body.index+'.'+body.testIndex+'.'+body.test, {
					body: JSON.stringify(body),
					cache: 'no-cache',
					headers: {
						'content-type': 'application/json',
					},
					method: 'POST',
					mode: 'cors'
				}).then(res=>res.text()).then((res:any)=>{
		
					res=(JSON.parse(res));
					
					let index =  res.index;
					let testIndex =  res.testIndex;
					let subtests =  [...this.state.subtests];
					let testOutput = {...this.state.testOutput};
					if (typeof(testOutput[index])==='undefined' || testOutput[index]===null) {
						testOutput[index] = [];
					}
					delete res.index;
					delete res.testIndex;
					delete res.test;
					delete res.domain;

					testOutput[index][testIndex] = JSON.parse(JSON.stringify(res));
					if (typeof(res.subtests)!=='undefined'){
						//console.debug(res)
						subtests = subtests.filter((subtest:any) => !(subtest.index === index && subtest.testIndex===testIndex  )) 
						res.subtests?.forEach((test:any, subtestIndex:number)=>{
							test.index = index;
							test.testIndex = testIndex;
							test.subtestIndex = subtestIndex;
							test.domain = this.state.sites[this.state.index];
							subtests.push(JSON.parse(JSON.stringify(test)))
						})
					}
					let next= this.setNextTest(this.state.testIndex, this.state.index);
					next.testOutput = testOutput;
					next.subtests =  subtests;
					this.setState(next)
				})
			} else { 
				if(!this.state.pause)
				setTimeout(()=>this.setState(this.setNextTest(this.state.testIndex, this.state.index)), this.state.testTimeout);
			}
		} else {
			if(!this.state.pause)
			setTimeout(()=>this.setState(this.setNextTest(this.state.testIndex, this.state.index)), this.state.testTimeout);
		}
	}
	setNextTest(testIndex:number, index:number):any{
		let lastPeriod =  JSON.parse(JSON.stringify(this.state.lastPeriod));
		let lastStart = JSON.parse(JSON.stringify(this.state.lastStart));
		
		if (testIndex+1 >= Object.keys(this.state.tests).length){
			testIndex = 0
			index++;
		} else {
			testIndex++;
		};
		if (index+1 > this.state.sites.length){
			index = 0;
			testIndex = 0
			this.getData();
			lastStart = (new Date()).getTime();
			lastPeriod = lastStart - this.state.lastStart;
		};
		let test=Object.keys(this.state.tests)[this.state.testIndex]
		let Test:any;
		for (let i in this.state.tests) {
			if (i===test){
				Test = this.state.tests[i]
			}
		}
		
		const next = {index:index,testCount:this.state.testCount+1, lastStart:lastStart,lastPeriod:lastPeriod, testIndex:testIndex};
		return next
		
	}
	render():React.ReactNode {
		let items:any[] = this.state?.sites||[];
		if (this.state.server!=='alle') {
			items = items.filter((item:any)=>item.server===this.state.server)
		}
		if (this.state.search!=='') {
			items = items.filter((item:any)=>item.domain.toLowerCase().indexOf(this.state.search)>=0)
		}
		const columns:IColumn[] = [
			{
				key:'number',
				name:"Nummer",
				fieldName:'domain',
				minWidth:20,
				maxWidth:80,
				onRender:(item?:any,index?:number)=>(this.state.sites.map((I:any)=>I.domain).indexOf(item.domain)+1)
			},
			{
				key:'domain',
				name:"Ssite",
				fieldName:'domain',
				minWidth:200,
				maxWidth:800,
				onRender:(item?:any)=><a href={item.link} target="_blank" rel="noopener noreferrer">{item.domain}</a>
			},
			{
				key:'server',
				name:"Server",
				fieldName:'server',
				minWidth:70,
				maxWidth:70
			},
			...Object.keys(this.state.tests).map((test:any, testIndex?:number|undefined)=>{
				return 		{
				key:'Process'+testIndex,
				name:this.state.tests[test]?.Name,
				onRender:(item:any, index?:number)=>{
					if (item?.type === 'filter') {
						return <></>
					}
					if (index===1 && item?.type === 'active') {
						index = this.state.index;
					}

					let result = this.state.testOutput[index||0]?.[testIndex||0];
					let {body,lastRun,haveToRun,Test} = this.getTest(testIndex||0,index||0);
					return (((index||0) === this.state.index || item.active  ) && this.state.testIndex === testIndex && haveToRun) ? <Spinner /> : <>
					{typeof(result)!=='undefined' && <>
						{result?.subtests?.length > 0  ? 
							<Subtests
								key={index}
								tests={this.state.subtests
								.filter((t:any)=>t.testIndex === testIndex && t.index === index).map((t:any,index:number)=>{
									t.subtestIndex=index;
									return t;
								})
								}
								onUpdate={(tests:any[])=>{
									let  subtests = [...this.state.subtests]
									tests.forEach((test:any)=>{
										subtests.forEach((subtest:any,i:number) => {
											if (test.index === subtest.index 
											 && test.testIndex===subtest.testIndex 
											 && test.subtestIndex===subtest.subtestIndex
											) {
												subtests[i] = test;
											}
										});
									})
									window.setTimeout(()=>
									this.setState({subtests:subtests}),this.state.testTimeout)
								}}
								pause={this.state.pause || this.state.lastPeriod===0}
								pausenGrund={this.state.lastPeriod===0?'erster Durchgang':''}
							/>

						:
							result.result 
							?<Icon iconName="CheckMark" title={JSON.stringify(result)} style={{color:'#008000', fontSize:'20px', position:'absolute'}}/>
							:<Icon iconName="ChromeClose"  title={JSON.stringify(result)} style={{color:'#800000', fontSize:'20px', position:'absolute'}}/>
						}
						<div style={{paddingLeft:'2em'}}>{result.statusText}</div>
					</>}
					</>
				},
				minWidth:100,
				maxWidth:100,
				isMultiline:true
			}}),
		]

		return <>
			<div style={{position:'relative',height:'100vh',display:'flex',flexDirection:'column'}} >
				
			<div key={'toolbar'} style={{height:'80px'}}>
			<CommandBar
				items={[{
						key:"playPause",
						iconOnly:true,
						iconProps:{
							iconName: this.state.pause ? 'PageRight':'CirclePause'
						},
						
						onClick:()=>this.setState({pause:!this.state.pause})
					},
					{
						key:"status",
						disabled:true,
						onRender:(item: any, dismissMenu: (ev?: any, dismissAll?: boolean) => void) =>{
							let ZeitALL=(((new Date()).getTime()-this.state.lastStart-this.state.testCount)/1000);
							return <span style={{display:'flex', height:'100%', width:'88vw', padding:'0 10px',alignItems:'center' }}>
							{ (this.state.index+1)+' / '+this.state.sites.length 
							+ ' // Zeit '+(((new Date()).getTime()-this.state.lastStart-this.state.testCount)/1000)
							+ ' // tests '+(this.state.testCount)
							+ ' // Zeit je Test '+(Math.round( ZeitALL / (this.state.testCount===0?1:this.state.testCount)*1000)/1000)
							+(this.state.lastPeriod > 0 ? ' // letzer Durchgang '+(this.state.lastPeriod/1000) :'')}</span>
						}
					}
				]}
			/>
 			</div>
			<div key={'main'} style={{position:'relative', flexGrow:1, display:'flex', alignItems:'stretch'}}>
				<div key={'items'} style={{position:'relative', flexGrow:1}}>
						<ScrollablePane>
							<DetailsList 
								items={items}
								columns={columns}
								compact={true}
								usePageCache={true}
								layoutMode={DetailsListLayoutMode.justified}
								constrainMode={ConstrainMode.unconstrained}
								selectionMode={SelectionMode.none}
								onRenderDetailsHeader={(props, defaultRender)=> {
								return (
									<Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
									{defaultRender!(props)}
									<DetailsRow 
										columns={props?.columns}
										itemIndex={1}
										selectionMode={SelectionMode.none}
										item={{
											domain:<SearchBox 
														onSearch={(newValue:any)=>this.setState({search:String(newValue)})} 
														onChange={(event?: React.ChangeEvent<HTMLInputElement> | undefined, newValue?: string | undefined)=>this.setState({search:String(newValue)})}
													/>,
											server:this.SeverDropdown(),
											type:"filter"
										}}
										key={'H'}
									/>
									<DetailsRow 
										key={'HH'}
										columns={props?.columns}
										itemIndex={1}
										selectionMode={SelectionMode.none}
										item={{...this.state.sites[this.state.index],active:true, type:'active', index:this.state.index}}
										styles={{root:{background:getTheme().palette.themeLighter}}}
									/>
									
									</Sticky>
								);
								}}
								onRenderRow={(props, defaultRender)=>{
									if(props?.itemIndex === this.state.index){
										props!.styles = {root:{background:getTheme().palette.themeLighter}}
									}
									return defaultRender!(props)
								}}
							/>
						</ScrollablePane>
				</div>
				<div style={{width:'2%'}}>
					{/*JSON.stringify(this.state.subtests) /** */}
				</div>
			</div>
			</div>
		</>
	}
	SeverDropdown(): React.ReactNode {
		
		let sites = this.state.sites
		.map((s:any)=>s.server)
		.sort((a:any, b:any) => a-b)
		.filter((s:any, index:number,self:any[])=>self.indexOf(s)===index);
		sites.unshift(["alle"]);
		return <Dropdown
		styles={{
			root:{display:'flex', height:'100%', width:'5em', padding:'0',alignItems:'center' },
			label:{paddingRight:'0.8em'},
			dropdown:{ flexGrow: 1}
		}}
		options={
				sites
				.map((s:any)=>{
					return {key:s, text:s}
				})
		}
		onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => this.setState({server:String(option?.key||'')})}
		selectedKey={this.state.server}
		/>
	}
}